export const FIELD_IS_REQUIRED = 'Field is required';
export const INPUT_LETTERS_ONLY = 'The input should contain only letters';
export const NOT_CORRECT_EMAIL = 'The input should be a correct email';
export const SHORT_PASSWORD = 'The password should contain minimul 6 letters';
export const NOT_MATCHING_PASSWORDS =
  'The passwords do not match, please try again';
